// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* طباعة كشف التسكين — جداول مرتبة */
@media print {
  @page {
    margin: 10mm;
    size: A4 portrait;
  }

  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
    overflow: visible !important;
    color: #111 !important;
  }

  body:has(.housing-report-print-root) > *:not(.housing-report-print-root) {
    display: none !important;
  }

  .housing-report-print-root {
    display: block !important;
    position: static !important;
    inset: auto !important;
    width: 100% !important;
    max-width: none !important;
    max-height: none !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    background: white !important;
    overflow: visible !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .housing-report-print-root .no-print {
    display: none !important;
  }

  .housing-report-print-sheet {
    direction: rtl;
    text-align: right;
    font-family: 'Segoe UI', Tahoma, Arial, sans-serif;
    color: #111;
  }

  .housing-report-header {
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 2px solid #111;
  }

  .housing-report-print-title {
    margin: 0;
    font-size: 18pt;
    font-weight: 700;
  }

  .housing-report-print-sub {
    margin: 4px 0 0;
    font-size: 10.5pt;
    color: #333;
  }

  .housing-report-info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 8px 14px;
    margin: 12px 0;
    padding: 10px 12px;
    border: 1px solid #ccc;
    background: #f7f7f7 !important;
    print-color-adjust: exact;
  }

  .housing-report-info-item {
    min-width: 0;
  }

  .housing-report-info-label {
    display: block;
    font-size: 8.5pt;
    color: #555;
    margin-bottom: 2px;
  }

  .housing-report-info-value {
    display: block;
    font-size: 10.5pt;
    font-weight: 600;
    color: #111;
  }

  .housing-report-counts {
    margin: 0 0 12px;
    font-size: 9.5pt;
    color: #444;
  }

  .housing-report-counts span {
    margin-inline-start: 2px;
  }

  .housing-report-rooms {
    display: block;
  }

  .housing-report-room {
    margin: 0 0 14px;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .housing-report-room-head {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
    margin-bottom: 4px;
    padding-bottom: 3px;
    border-bottom: 1px solid #999;
  }

  .housing-report-room-title {
    margin: 0;
    font-size: 12pt;
    font-weight: 700;
  }

  .housing-report-room-meta {
    font-size: 9pt;
    color: #444;
  }

  .housing-report-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 10pt;
  }

  .housing-report-table th,
  .housing-report-table td {
    border: 1px solid #bbb;
    padding: 5px 8px;
    text-align: right;
    vertical-align: middle;
  }

  .housing-report-table th {
    background: #eee !important;
    font-weight: 600;
    font-size: 9pt;
    color: #333;
    print-color-adjust: exact;
  }

  .housing-report-table .bed-num {
    width: 56px;
    text-align: center;
  }

  .housing-report-table .bed-name {
    font-weight: 600;
  }

  .housing-report-table .bed-booking {
    width: 110px;
  }

  .housing-report-table .bed-phone {
    width: 110px;
    direction: ltr;
    text-align: left;
  }

  .housing-report-empty {
    padding: 24px 0;
    text-align: center;
    color: #666;
    font-size: 11pt;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Housing/housing-report-print.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,4BAA4B;IAC5B,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kDAAkD;IAClD,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,kCAAkC;IAClC,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,8BAA8B;IAE9B,yBAAyB;EAC3B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;;EAEA;;IAEE,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;IACd,WAAW;IAEX,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":["/* طباعة كشف التسكين — جداول مرتبة */\n@media print {\n  @page {\n    margin: 10mm;\n    size: A4 portrait;\n  }\n\n  html,\n  body {\n    margin: 0 !important;\n    padding: 0 !important;\n    background: white !important;\n    overflow: visible !important;\n    color: #111 !important;\n  }\n\n  body:has(.housing-report-print-root) > *:not(.housing-report-print-root) {\n    display: none !important;\n  }\n\n  .housing-report-print-root {\n    display: block !important;\n    position: static !important;\n    inset: auto !important;\n    width: 100% !important;\n    max-width: none !important;\n    max-height: none !important;\n    height: auto !important;\n    margin: 0 !important;\n    padding: 0 !important;\n    background: white !important;\n    overflow: visible !important;\n    box-shadow: none !important;\n    border-radius: 0 !important;\n  }\n\n  .housing-report-print-root .no-print {\n    display: none !important;\n  }\n\n  .housing-report-print-sheet {\n    direction: rtl;\n    text-align: right;\n    font-family: 'Segoe UI', Tahoma, Arial, sans-serif;\n    color: #111;\n  }\n\n  .housing-report-header {\n    margin-bottom: 10px;\n    padding-bottom: 8px;\n    border-bottom: 2px solid #111;\n  }\n\n  .housing-report-print-title {\n    margin: 0;\n    font-size: 18pt;\n    font-weight: 700;\n  }\n\n  .housing-report-print-sub {\n    margin: 4px 0 0;\n    font-size: 10.5pt;\n    color: #333;\n  }\n\n  .housing-report-info-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 8px 14px;\n    margin: 12px 0;\n    padding: 10px 12px;\n    border: 1px solid #ccc;\n    background: #f7f7f7 !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .housing-report-info-item {\n    min-width: 0;\n  }\n\n  .housing-report-info-label {\n    display: block;\n    font-size: 8.5pt;\n    color: #555;\n    margin-bottom: 2px;\n  }\n\n  .housing-report-info-value {\n    display: block;\n    font-size: 10.5pt;\n    font-weight: 600;\n    color: #111;\n  }\n\n  .housing-report-counts {\n    margin: 0 0 12px;\n    font-size: 9.5pt;\n    color: #444;\n  }\n\n  .housing-report-counts span {\n    margin-inline-start: 2px;\n  }\n\n  .housing-report-rooms {\n    display: block;\n  }\n\n  .housing-report-room {\n    margin: 0 0 14px;\n    page-break-inside: avoid;\n    break-inside: avoid;\n  }\n\n  .housing-report-room-head {\n    display: flex;\n    align-items: baseline;\n    justify-content: space-between;\n    gap: 8px;\n    margin-bottom: 4px;\n    padding-bottom: 3px;\n    border-bottom: 1px solid #999;\n  }\n\n  .housing-report-room-title {\n    margin: 0;\n    font-size: 12pt;\n    font-weight: 700;\n  }\n\n  .housing-report-room-meta {\n    font-size: 9pt;\n    color: #444;\n  }\n\n  .housing-report-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 10pt;\n  }\n\n  .housing-report-table th,\n  .housing-report-table td {\n    border: 1px solid #bbb;\n    padding: 5px 8px;\n    text-align: right;\n    vertical-align: middle;\n  }\n\n  .housing-report-table th {\n    background: #eee !important;\n    font-weight: 600;\n    font-size: 9pt;\n    color: #333;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .housing-report-table .bed-num {\n    width: 56px;\n    text-align: center;\n  }\n\n  .housing-report-table .bed-name {\n    font-weight: 600;\n  }\n\n  .housing-report-table .bed-booking {\n    width: 110px;\n  }\n\n  .housing-report-table .bed-phone {\n    width: 110px;\n    direction: ltr;\n    text-align: left;\n  }\n\n  .housing-report-empty {\n    padding: 24px 0;\n    text-align: center;\n    color: #666;\n    font-size: 11pt;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
